/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassInfoResponse
 */
export interface ClassInfoResponse {
    /**
     * The id of the class
     * @type {string}
     * @memberof ClassInfoResponse
     */
    id: string;
    /**
     * Metadata about the class
     * @type {string}
     * @memberof ClassInfoResponse
     */
    classMetadata: string;
    /**
     * The date the class was created
     * @type {string}
     * @memberof ClassInfoResponse
     */
    createdDate: string;
    /**
     * The id of the professor associated with the class
     * @type {string}
     * @memberof ClassInfoResponse
     */
    professorId: string;
}

/**
 * Check if a given object implements the ClassInfoResponse interface.
 */
export function instanceOfClassInfoResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "classMetadata" in value;
    isInstance = isInstance && "createdDate" in value;
    isInstance = isInstance && "professorId" in value;

    return isInstance;
}

export function ClassInfoResponseFromJSON(json: any): ClassInfoResponse {
    return ClassInfoResponseFromJSONTyped(json, false);
}

export function ClassInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'classMetadata': json['classMetadata'],
        'createdDate': json['createdDate'],
        'professorId': json['professorId'],
    };
}

export function ClassInfoResponseToJSON(value?: ClassInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'classMetadata': value.classMetadata,
        'createdDate': value.createdDate,
        'professorId': value.professorId,
    };
}

